import React from 'react';
import * as PropTypes from "prop-types";
import {Stage, Layer} from 'react-konva';
import PlantManagementUtility from "./PlantManagementUtility";
import HeatExchangerInLayout from "./HeatExchangerInLayout";

export class Layout extends React.Component {
    constructor(props) {
        super(props);

        // ※refを使用するので@material-ui/coreのversion3.Xの場合,対象のコンポーネントがwithStylesでラッピングされていないことを確認すること.
        this.heatExchangerInLayoutRefs = []; // 点滅機能用に熱交のDOMの参照の配列を保持.

        this.moveToTop = this.moveToTop.bind(this);
        this.setHeatExchangerPosition = this.setHeatExchangerPosition.bind(this);
        this.startBlink = this.startBlink.bind(this);
        this.stopBlink = this.stopBlink.bind(this);
        this.updateHeatExchangerInLayoutRefs = this.updateHeatExchangerInLayoutRefs.bind(this);

        this.updateHeatExchangerInLayoutRefs();
    }

    moveToTop(heatExchangerId) {
        let heatExchanger = PlantManagementUtility.getHeatExchangerInLayoutRefByHeatExchangerId(this.heatExchangerInLayoutRefs, heatExchangerId);
        heatExchanger.current.moveToTop();
    }

    setHeatExchangerPosition(heatExchangerId, x, y) {
        let heatExchanger = PlantManagementUtility.getHeatExchangerInLayoutRefByHeatExchangerId(this.heatExchangerInLayoutRefs, heatExchangerId);
        heatExchanger.current.setPosition(x, y);
    }

    startBlink(heatExchangerId, timeout) {
        let heatExchanger = PlantManagementUtility.getHeatExchangerInLayoutRefByHeatExchangerId(this.heatExchangerInLayoutRefs, heatExchangerId);
        heatExchanger.current.moveToTop();
        heatExchanger.current.startBlink();
        setTimeout(heatExchanger.current.stopBlink, timeout);
    }

    stopBlink() {
        for (let i = 0; i < this.heatExchangerInLayoutRefs.length; i++) {
            this.heatExchangerInLayoutRefs[i].current.stopBlink();
        }
    }

    updateHeatExchangerInLayoutRefs() {
        this.heatExchangerInLayoutRefs = [];
        for (let i = 0; i < this.props.heatExchangerArray.length; i++) {
            this.heatExchangerInLayoutRefs.push(React.createRef());
        }
    }

    render() {
        // 点滅機能用に熱交のDOMの参照の配列を再構築.
        this.updateHeatExchangerInLayoutRefs();

        return (
            <Stage
                width={this.props.width}
                height={this.props.height}
                style={{
                    border: 2,
                    borderStyle: 'solid',
                    margin: 'auto',
                    width: this.props.width,
                    height: this.props.height,
                }}
            >
                <Layer>
                    {this.props.heatExchangerArray.map((row, i) => {
                        return (
                            <HeatExchangerInLayout
                                key={i}
                                ref={this.heatExchangerInLayoutRefs[i]}
                                currentLayoutIndex={this.props.currentLayoutIndex}
                                heatExchanger={row}
                                layoutArray={this.props.layoutArray}
                                layoutWidth={this.props.width}
                                layoutHeight={this.props.height}
                                onDragEnd={this.props.onDragEndHeatExchangerInLayout}
                                onMoveLayout={this.props.onMoveLayoutHeatExchangerInLayout}
                                onTapOrClickBody={this.props.onTapOrClickHeatExchangerInLayoutBody}
                                onTapOrClickRotationArrow={this.props.onTapOrClickHeatExchangerInLayoutRotationArrow}
                                visible={row.sceneDetailNumber === this.props.layoutArray[this.props.currentLayoutIndex].sceneDetailNumber && !PlantManagementUtility.isParamTrue(row.resultOfProcessIsCompleteCarryOut)}
                                isDisabled={this.props.isDisabled}
                            />
                        )
                    })}
                </Layer>
            </Stage>
        );
    }
}

Layout.propTypes = {
    currentLayoutIndex: PropTypes.number.isRequired,
    heatExchangerArray: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
    layoutArray: PropTypes.array.isRequired,
    onDragEndHeatExchangerInLayout: PropTypes.func.isRequired,
    onMoveLayoutHeatExchangerInLayout: PropTypes.func.isRequired,
    onTapOrClickHeatExchangerInLayoutBody: PropTypes.func.isRequired,
    onTapOrClickHeatExchangerInLayoutRotationArrow: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    isDisabled: PropTypes.bool.isRequired,
};

export default Layout;
